import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
  isAuthenticated: false,
  admin: false,
  roles: [],
  refreshToken: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.admin = action.payload.admin;
      state.refreshToken = action.payload.refreshToken;
      state.roles = action.payload.roles || [];
      // save token and refreshToken to localStorage
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("refreshToken", action.payload.refreshToken);
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      state.roles = [];
      state.admin = false;
      state.isAuthenticated = false;
      // remove token and refreshToken from localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
    },
    setTokens: (state, action) => {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("refreshToken", action.payload.refreshToken);
    },
    updateUser: (state, action) => {
      state.user.name = action.payload.name;
      state.user.email = action.payload.email;
      state.user.phone = action.payload.phone;
    },
  },
});

export const { login, logout, setTokens, updateUser } = authSlice.actions;

export default authSlice.reducer;
